/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * the type of appointment
 * @export
 * @interface AppointmentType
 */
export interface AppointmentType {
    /**
     * the unique identifier of a appointment type
     * @type {string}
     * @memberof AppointmentType
     */
    uuid?: string;
    /**
     * the name of the type of appointment
     * @type {string}
     * @memberof AppointmentType
     */
    name?: string;
    /**
     * new appointment types order
     * @type {number}
     * @memberof AppointmentType
     */
    order?: number;
    /**
     * Note from the health pro for the patient
     * @type {string}
     * @memberof AppointmentType
     */
    note?: string;
}

/**
 * Check if a given object implements the AppointmentType interface.
 */
export function instanceOfAppointmentType(value: object): value is AppointmentType {
    return true;
}

export function AppointmentTypeFromJSON(json: any): AppointmentType {
    return AppointmentTypeFromJSONTyped(json, false);
}

export function AppointmentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentType {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'name': json['name'] == null ? undefined : json['name'],
        'order': json['order'] == null ? undefined : json['order'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AppointmentTypeToJSON(json: any): AppointmentType {
    return AppointmentTypeToJSONTyped(json, false);
}

export function AppointmentTypeToJSONTyped(value?: AppointmentType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'name': value['name'],
        'order': value['order'],
        'note': value['note'],
    };
}

